module.exports = __webpack_public_path__ + "static/bluefocus_ai_logo_white_color.a7c375f4.png";